// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__47zaJ","selects":"Documents_selects__2YDRD"};